export default __webpack_public_path__ + "static/media/logo-synapse40x38.bb28bec5.svg";